import { provideTanStackQuery, QueryClient } from '@tanstack/angular-query-experimental';
import { withDevtools } from '@tanstack/angular-query-experimental/devtools/production';
import { broadcastQueryCacheState } from '@core/tanstack/tanstack-cache-sync';
import { signal } from '@angular/core';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false
      // staleTime: 5000 // cinque secondi
    }
  }
});

// Sync delle query su più schede
broadcastQueryCacheState(queryClient);

const tsDevToolsEnabled = signal(false);

export const toggleDevTools = (enable: boolean) => {
  tsDevToolsEnabled.set(enable);
};

export const ProvideTanstack = provideTanStackQuery(
  queryClient,
  withDevtools(() => ({
    loadDevtools: tsDevToolsEnabled()
  }))
);
